import type { CreateConfigurationDto } from "@/dtos/CreateConfigurationDto";
import type { UpdateConfigurationDto } from "@/dtos/UpdateConfigurationDto";
import api from "@/services/api";
import { useMutation, useQuery } from "@tanstack/react-query";

export const useCreateConfiguration = () => {
  return useMutation({
    mutationKey: ["createConfiguration"],
    mutationFn: async (createConfigurationDto: CreateConfigurationDto) => {
      const response = await api.post("/settings", createConfigurationDto);

      return response.data;
    },
  });
};

export const useUpdateConfiguration = () => {
  return useMutation({
    mutationKey: ["updateConfiguration"],
    mutationFn: async (updateConfigurationDto: UpdateConfigurationDto) => {
      const response = await api.patch("/settings", updateConfigurationDto);

      return response.data;
    },
  });
};

export const useGetConfiguration = () => {
  return useQuery({
    queryKey: ["getConfiguration"],
    queryFn: async () => {
      try {
        const response = await api.get("/settings");
        return response.data;
      } catch (error: any) {
        // Se for 404, retorna null (configuração não existe ainda)
        if (error?.response?.status === 404) {
          return null;
        }
        // Para outros erros, propaga o erro
        throw error;
      }
    },
    retry: false, // Não tenta novamente em caso de erro
  });
};

export const useGetConfigurationHistory = () => {
  return useQuery({
    queryKey: ["getConfigurationHistory"],
    queryFn: async () => {
      const response = await api.get("/settings/history");
      return response.data;
    },
  });
};
